import { Link } from "react-router-dom";
export default function Brand({ light = false }) { return <Link to="/home" className={`brand text-decoration-none ${light ? "text-white" : ""}`}><span className="brand-mark"><i className="fa-solid fa-leaf" /></span> freshloop</Link>; }
